const initialState = {
  data:[],
}
const TicketAdditionaFormReducer = (state = initialState, action: { type: any; payload: any; }) => {
  switch (action.type) {
      case 'STORE_TICKET_ADDITIONAL_FORM':
          return {
              ...state,
              data: action.payload,
          };
      default:
          return state;
  }
}

export default TicketAdditionaFormReducer;
